<!-- <div class="scrollable-y m-15 manage-apps-page"> -->
<div class="row">
  <div class="col-md-12">
    <div class="pages-header">
      <h1 class="mobile-move-title">Manage Available Resources</h1>
    </div>
    <div class="panel panel-default">
      <div class="panel-body">
        <div class="manage-resources-list">
          <div class="row">
            <div class="col-12">
              <div style="display: inline-block">
                <span>
                  <!-- <h4 class="manage-apps-filter"><span class="library-name">{{current_library.name}}</span> <i class="feather chevron-down"></i></h4> -->
                  <h4 class="manage-apps-filter" style="cursor: default">
                    <span class="library-name">Available Resources</span>
                    <!--<i class="feather chevron-down"></i>-->
                  </h4>
                </span>
                <!-- <ul *dropdownMenu class="dropdown-menu" role="menu" style="left:15px;top:30px">
                                        <li role="menuitem" (click)="change_library('global')"><a class="dropdown-item">Global Library</a></li>
                                        <li role="menuitem" (click)="change_library('practice')"><a class="dropdown-item">Practice Library</a></li>
                                    </ul> -->
              </div>
              <div class="manage-apps-search">
                <i class="feather search"></i>
                <input
                  type="text"
                  [(ngModel)]="search"
                  placeholder="Search in Resources"
                />
              </div>
            </div>
          </div>
          <p *ngIf="current_library.name == 'Global Library'">
            Click on a resource to view it.
          </p>
          <p *ngIf="current_library.name == 'Practice Library'">
            Click on a resource to edit details.
          </p>

          <nav class="default-tabs tabs">
            <div class="tabs-wrapper" style="padding-left: 0">
              <a
                [ngClass]="{
                  active: current_library.name == 'Practice Library'
                }"
                (click)="change_library('practice')"
                >Firm Library</a
              >
              <a
                [ngClass]="{ active: current_library.name == 'Global Library' }"
                (click)="change_library('global')"
                >Client Hub Library</a
              >
            </div>
          </nav>

          <div
            class="row not-selected-resources-list manage-resources-list scrollbars"
          >
            <div
              class="col-md-4"
              *ngIf="current_library.name == 'Practice Library'"
            >
              <a
                href="javascript:"
                (click)="openResourceModal(resource, true)"
                class="resources-item resources-item-add"
              >
                <div class="resources-thumb">
                  <i
                    class="feather plus x3"
                    style="
                      margin-left: 14px;
                      margin-top: 9px;
                      display: inline-block;
                      color: #485364 !important;
                    "
                  ></i>
                </div>
                <div class="resources-content">
                  <div class="resources-content-wrapper">
                    <div class="resources-type">&nbsp;</div>
                    <div class="resources-title" style="top: 15px">
                      New Resource
                    </div>
                    <div class="resources-description" style="padding-top: 3px">
                      Click to add a new resource
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div
              class="col-md-4"
              *ngFor="
                let resource of current_library.bucket
                  | resourceSearch : search;
                let i = index
              "
              (click)="
                current_library.name == 'Practice Library'
                  ? openResourceModal(resource, false)
                  : return
              "
            >
              <app-resources-item
                [resource]="resource"
                [link]="
                  current_library.name == 'Practice Library' ? false : true
                "
              >
              </app-resources-item>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- </div> -->
